<div class="padding bg-light-grey">
	<div class="flex center">Styles</div>
</div>

<div class="padding page-layout">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Styles</h4>
		</div>
	</div>

	<div class="chip-container flex wrap">
		@for (element of filtersList; track element) {
			@let label = getLabel(element.id);
			<div (click)="openDialogFilter(element.id)" class="filter-chip" [ngClass]="!label ? ' ' : 'selected'" [title]="getFullTitleFilter(element.id)">
				@if (label) {
					<b>{{ element.label }}</b>
					: {{ label }}
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				} @else {
					{{ element.label }}
					<mat-icon>edit</mat-icon>
				}
			</div>
		}
	</div>

	<bt-loader [loaderId]="loaderId">
		@if (database.data) {
			<div class="flex margin-bottom-small margin-top">
				<div class="flex-1 flex end">
					<span class="grey">{{ database.total }} styles</span>
				</div>
				<div class="flex-0 flex center"></div>
			</div>

			<table class="margin-top-small basic-table">
				<tr>
					<th>Style</th>
					<th>Brand</th>
					<th>Category</th>
					<th>Warehouse</th>
					<th>Orders</th>
					<th>Action</th>
				</tr>

				@for (item of database.data; track item) {
					<tr>
						<td>{{ item.styleCode }} {{ item.styleName }}</td>
						<td>{{ item.brandName }}</td>
						<td>{{ item.categoryName }}</td>
						<td>{{ item.warehouses.length }}</td>
						<td>{{ item.ordersInfo.length }}</td>
						<td>
							<div class="flex center">
								<span class="hover flex center margin-right primary" (click)="onStyleInfo(item)">
									<i class="fa fa-eye margin-right-small"></i>
									Open
								</span>

								<span
									class="hover flex center margin-right"
									(click)="onStyleSketch(item)"
									[ngClass]="!item.sketchImgPath ? 'disabled' : ''">
									<i class="fa fa-eye margin-right-small"></i>
									Sketch
								</span>

								<span class="hover flex center margin-right" [ngClass]="!item.ordersInfo.length ? 'disabled' : ''">
									<!-- (click)="onStyleSidebarInfo(item, 'Style orders')" -->
									<i class="fa fa-list margin-right-small"></i>
									orders
								</span>

								<span class="hover flex center margin-right" [ngClass]="!item.warehouses?.length ? 'disabled' : ''">
									<!-- (click)="onStyleSidebarInfo(item, 'Style warehouses')" -->
									<i class="fa fa-list margin-right-small"></i>
									warehouses
								</span>

								<span class="hover flex center red" disabled>
									<!-- (click)="onReshootStyle(item)" -->
									<i class="fa fa-trash margin-right-small"></i>
									Reshoot
								</span>
							</div>
						</td>
					</tr>
				}
			</table>

			<bt-paginator
				[pageNumber]="database.pageNumber"
				[pageSize]="database.pageSize"
				[totalNumber]="database.total"
				(clickPage)="getCompanyStyles($event)"></bt-paginator>
		}
	</bt-loader>

	<!-- @if (currentSidebar === sidebarTypeEnum.customSidebar && customSidebarTitle === 'Style orders') {
			<bt-sidebar [sidebarTitle]="customSidebarTitle" (exit)="onExitSidebar()">
				@if (database.tmp) {
					<div class="full-height flex">
						<div class="flex-0 margin-top-large margin-bottom-large padding-left-x-small padding-right-x-small">
							This is the list of orders related to style
							<b>{{ database.tmp.fullName }}</b>
							.
						</div>
						<div class="flex-1 overflow margin-bottom padding-left-x-small padding-right-x-small">
							<table>
								<tr>
									@for (col of ordersGridColumns; track col) {
										<th [ngStyle]="{ width: col.width ? col.width + 'px' : null }">
											{{ col.title }}
										</th>
									}
								</tr>
								@for (item of database.tmp.ordersInfo; track item) {
									<tr>
										@for (col of ordersGridColumns; track col) {
											<td>
												@if (col.type === gridColumnTypeEnum.default) {
													<ng-container>
														{{ item[col.field] || ' - ' }}
													</ng-container>
												}
												@if (col.type === gridColumnTypeEnum.icon) {
													<ng-container>
														<div
															class="pointer flex center justify-center"
															(click)="onOrderInfo(item)">
															<i class="fa fa-info"></i>
														</div>
													</ng-container>
												}
											</td>
										}
									</tr>
								}
							</table>
						</div>
						<div class="flex-0">
							<button class="full-width" (click)="onOrderList()">
								<i class="fa fa-external-link"></i>
								Go to order list
							</button>
						</div>
					</div>
				}
			</bt-sidebar>
		}

		@if (currentSidebar === sidebarTypeEnum.customSidebar && customSidebarTitle === 'Style warehouses') {
			<bt-sidebar [sidebarTitle]="customSidebarTitle" (exit)="onExitSidebar()">
				@if (database.tmp) {
					<div class="full-height flex">
						<div class="flex-0 margin-top-large margin-bottom-large padding-left-x-small padding-right-x-small">
							This is the list of warehouses related to style
							<b>{{ database.tmp.fullName }}</b>
							.
						</div>
						<div class="flex-1 overflow margin-bottom padding-left-x-small padding-right-x-small">
							<table>
								<tr>
									@for (col of warehouseGridColumns; track col) {
										<th [ngStyle]="{ width: col.width ? col.width + 'px' : null }">
											{{ col.title }}
										</th>
									}
								</tr>
								@for (item of database.tmp.warehouses; track item) {
									<tr>
										@for (col of warehouseGridColumns; track col) {
											<td>
												@if (col.type === gridColumnTypeEnum.default) {
													<ng-container>
														{{ item[col.field] || ' - ' }}
													</ng-container>
												}
											</td>
										}
									</tr>
								}
							</table>
						</div>
						<div class="flex-0">
							<button class="full-width" (click)="onOrderList()">
								<i class="fa fa-external-link"></i>
								Go to order list
							</button>
						</div>
					</div>
				}
			</bt-sidebar>
		}

		@if (currentSidebar === sidebarTypeEnum.deleteAction) {
			<bt-sidebar sidebarTitle="Reshoot entire style" (exit)="onExitSidebar()">
				<bt-loader [loaderId]="sidebarLoaderId">
					@if (database.tmp) {
						<div class="flex column full-height">
							<div class="flex-1 flex center justify-center">
								<div>
									Are you sure you want to
									<b>reshoot</b>
									entire style {{ database.tmp.fullName }}?
									<br />
									<br />
									All style shots will be deleted.
								</div>
							</div>
							<div class="flex-0">
								<button class="full-width warning" (click)="reshootStyle()">
									<i class="fa fa-trash"></i>
									Reshoot entire style
								</button>
							</div>
						</div>
					}
				</bt-loader>
			</bt-sidebar>
		} -->
</div>
